var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showChart)?_c('base-bar-chart',{staticStyle:{"max-height":"250px"},attrs:{"chart-data":_vm.dataCollection,"options":_vm.options}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }